import type {SlotGameSubController} from "@gamzix/slot_core";

//@ts-ignore
class GameSlotGameSubController extends SlotGameSubController {
    constructor(game) {
        super(game);

        this.addCustomPhases(["bonusAlign"], "IDLE", "holdPositions");
        this.addCustomPhases(["showBonusWin"], "CHECK", "checkStartBonusGame");
        this.addCustomPhases(["showBonusCluster"], "CHECK", "exit");
    }
}

export {GameSlotGameSubController};

Game.src.subController.GameSubController = GameSlotGameSubController;

